import { connect } from 'react-redux';

import { PropertyGuides } from './PropertyGuides';
import { getPropertyGuidesGroup, EPropertyGuidesGroups } from '../../utils/ab_mainpage_property_guides';

import { IReduxState } from '../../types/redux';

interface IStateProps {
  experiment: EPropertyGuidesGroups;
}

export function mapStateToProps({ mainpage }: IReduxState): IStateProps {
  return {
    experiment: getPropertyGuidesGroup(mainpage.experiments || []),
  };
}

export const PropertyGuidesContainer = connect(mapStateToProps)(PropertyGuides);
